import { type FC } from 'react'
import { BookingStatus } from '../../models/Scheduling'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useGetBookingsQuery } from '../../store/scheduling/scheduling'
import { AlertIcon } from '../AlertIcon/AlertIcon'
import { useZocksQuota } from '../ScopedBlock/hooks'
import { hasSchedulingAlert } from './hasSchedulingAlert'

const ALERT_POLLING_INTERVAL = 30000
const ALERT_PAGE_REQUEST = { page: 0, size: 1 }
const ALERT_QUERY_OPTIONS = { refetchOnMountOrArgChange: true, pollingInterval: ALERT_POLLING_INTERVAL, skipPollingIfUnfocused: true }

export const SchedulingMenuIcon: FC = () => {
  const { hasQuota } = useZocksQuota()
  const schedulingEnabled = hasQuota('scheduling.enabled.value')
  const authenticatedUser = useAppSelector(selectSafeAuthenticatedUser)
  const alertArgs = { accountId: authenticatedUser.accountId, userIds: [authenticatedUser.id], pageRequest: ALERT_PAGE_REQUEST }
  const getBookingsQueryArgs = { ...ALERT_QUERY_OPTIONS, skip: !schedulingEnabled }
  const { data: requests } = useGetBookingsQuery({ ...alertArgs, status: BookingStatus.REQUESTED }, getBookingsQueryArgs)
  const { data: suggestions } = useGetBookingsQuery({ ...alertArgs, status: BookingStatus.OPPORTUNITY }, getBookingsQueryArgs)
  const hasAlert = hasSchedulingAlert(requests?.page.totalElements ?? 0, suggestions?.page.totalElements ?? 0)

  return (
    <AlertIcon size={1.8} active={hasAlert}>
      <i className='bi bi-calendar' />
    </AlertIcon>
  )
}
